import classNames from 'classnames/bind';
import React from 'react';
import { Link } from 'react-router-dom';
import { List, ListItem } from 'semantic-ui-react';
import { Modal, ModalWidth } from '@creditsights/styleguide-web';

import { useGlobalModalContext } from '../GlobalModal';
import styles from './LinkListModal.module.scss';

const cx = classNames.bind(styles);

export interface LinkListItem {
  title: string;
  url: string;
}

export interface LinkListModalProps {
  title: string;
  items: LinkListItem[];
}

const LinkListModal = ({ title, items }: LinkListModalProps): React.ReactElement => {
  const { closeModal } = useGlobalModalContext();

  return (
    <Modal
      className={cx('body')}
      width={ModalWidth.Small}
      open
      onClose={closeModal}
      headerTitle={title}
      data-testid="link-list-modal"
    >
      <List>
        {items.map((item) => (
          <ListItem key={item.title}>
            <div className={cx('item')}>
              <Link to={item.url} data-testid="link-list-item">
                {item.title}
              </Link>
            </div>
          </ListItem>
        ))}
      </List>
    </Modal>
  );
};

export default LinkListModal;
